import React, { Component } from "react";
import { withTranslation } from 'react-i18next';
import SearchInput from "../../../../common/components/UI/Search/SearchInput";
import { DateFnsFormats, formatAs } from "../../../../common-client2/src/services/ukgDateTime";
import { getValidationFailureMessages } from "../../../Utils/ValidationFailureFormatter";
import './HistoryPanel.scss';

class HistoryPanel extends Component {
	constructor(props) {
		let logs = props.historyResponse.map(entry => ({
			...entry,
			managerSettingName: props?.managerSettingNames[entry.managerSettingId],
			dateDisplay: formatAs(entry.dateLogged, DateFnsFormats.VERBOSE_LONG_DATETIME_FORMAT),
		}));
		super(props);
		this.state = {
			historyLog: logs,
			filteredHistoryLog: logs,
			expanded: true,
			searchValue: '',
		};
	}

	componentDidUpdate = (prevProps) => {
		if (this.props.historyResponse) {
			if (this.props.historyResponse !== prevProps.historyResponse) {
				let logs = this.props.historyResponse.map(entry => {
					return {
						...entry,
						managerSettingName: this.props.managerSettingNames[entry.managerSettingId],
						dateDisplay: formatAs(entry.dateLogged, DateFnsFormats.VERBOSE_LONG_DATETIME_FORMAT),
					}
				});
				this.setState({
					historyLog: logs,
					filteredHistoryLog: logs,
				});
			}
		}
	}

	renderHistoryList = () => {
		const { handleClick = () => { }, isClickable, t } = this.props;
		const { filteredHistoryLog } = this.state;

		if (!filteredHistoryLog.length) {
			return <div style={{ color: '#dedede', paddingLeft: 10 }}>None</div>;
		}

		return filteredHistoryLog.map((item, index) => {
			const isExpiredDueToInactivity = item.message === 'IsExpiredDueToInactivity' && item.employeeName === 'Auto-Expiry';
			const failureMessages = getValidationFailureMessages(item, this.props.t);
			const hasValidationFailures = failureMessages.length > 0;

			return (
			  <div
				style={{
					cursor: isClickable ? 'pointer' : 'default',
					border: hasValidationFailures ? '2px solid #f44336' : 'none',
					borderRadius: hasValidationFailures ? '4px' : '0',
					backgroundColor: hasValidationFailures ? '#ffebee' : 'transparent',
					padding: hasValidationFailures ? '8px' : '0'
				}}
				onClick={() => handleClick(item.offerId)}
				key={'historyLog' + index}
				className="history-item-container"
			  >
				<div className="history-log-first">
						<span className="history-log-name">{item.employeeName?.trim() || ""}</span>
				  		<span> {item.status?.trim() || ""} </span>
				  		<span className="history-log-shift-time">{item.managerSettingName?.trim() || ""}</span>
				  {isExpiredDueToInactivity && <span> due to inactivity</span>}
				</div>
				<div className="history-log-date">{item.dateDisplay}</div>

				{!isExpiredDueToInactivity && !!item.message && (
				  <span className="history-log-name">
					{`${item.employeeName} commented "${item.message}"`}
				  </span>
				)}

				{hasValidationFailures && (
				  <div style={{ marginTop: '8px', color: '#d32f2f' }}>
					<div style={{ fontWeight: 'bold', fontSize: '12px', marginBottom: '4px' }}>
					  {this.props.t('validationFailureDetails.historyTitle')}
					</div>
					<ul style={{ margin: '0', paddingLeft: '16px', fontSize: '11px' }}>
					  {failureMessages.map((message, failureIndex) => (
						<li key={`validation-${index}-${failureIndex}`} style={{ marginBottom: '2px' }}>
						  {message}
						</li>
					  ))}
					</ul>
				  </div>
				)}
			  </div>
			);
		  });
		  
	}

	handleSearchFilter = (event) => {
		const { searchValue, historyLog } = this.state;

		let filteredHistoryLog = [];

		let searchFilter = (event.target.value === undefined) ? searchValue : event.target.value;
		let keys = ['employeeName', 'dateDisplay', 'managerSettingName', 'status'];
		if (searchFilter !== '') {
			for (const entry of historyLog) {
				for (const key in entry) {
					if (keys.includes(key)
						&& entry[key]
						&& entry[key].toLowerCase().includes(searchFilter.toLowerCase())) {
						filteredHistoryLog.push(entry)
						break;
					}
				}
			}
		} else {
			filteredHistoryLog = historyLog;
		}

		this.setState({
			searchValue: searchFilter,
			filteredHistoryLog: filteredHistoryLog,
		})
	}

	render() {
		const { hasSearch } = this.props;
		const { searchValue } = this.state;
		let searchBar = (hasSearch) ?
			<SearchInput
				wrapperClass="history-search-input"
				fullWidth={true}
				value={searchValue}
				placeholder={"Search"}
				onChange={this.handleSearchFilter}
			/> : ''
		return (
			<React.Fragment>
				{searchBar}
				{this.renderHistoryList()}
			</React.Fragment>
		);
	}
}
export default withTranslation('employmentBillboard')(HistoryPanel);